import React, { useState, useEffect, useRef, useCallback } from "react";
import { StyleSheet, View, SafeAreaView, Platform, useWindowDimensions, FlatList, ActivityIndicator, } from "react-native";
import { Card, Checkbox } from "react-native-paper";
import { useTheme } from "@react-navigation/native";
import { createCommonStyles } from "../../../styles/commonStyles";
import CustomLabel from "../../../components/CustomLabel/CustomLabel";
import CustomInput from "../../../components/CustomInput";
import CustomButton from "../../../components/CustomButton";
import Ionicons from "@react-native-vector-icons/ionicons/static";
import CustomDropDown from "../../../components/CustomDropDown/CustomDropdown";
import { useTranslation } from "react-i18next";
import CustomCalendar from "../../../components/CustomCalendar/CustomCalendar";
import { formatDateForUI, changeDateFromYYYYMMDDToDDMMYYYY } from "../../../constants/FormatDate";
import { useHRAdminEmployees } from "../../../hooks/useHRAdminEmployees";
import { useTableHelper } from "../../../hooks/useTableHelper";
import { showMessage } from "react-native-flash-message";
import * as ExpoDocumentPicker from "expo-document-picker";
import CustomText from '../../../components/CustomText/CustomText';
import {
  Menu,
  MenuOptions,
  MenuOption,
  MenuTrigger,
  renderers,
} from 'react-native-popup-menu';

const ExitProcessListView = React.memo(
  ({ item, index, handleEditPress, styles, t, emplExitProcessHelper, handleDelete, resetDates }) => {

    const [isExpanded, setIsExpanded] = useState(false);
    const [fieldName, setFieldName] = useState("")
    const [showCalendarDoe, setShowCalendarDoe] = useState(false);
    const [showCalendarDor, setShowCalendarDor] = useState(false);
    const [selectedData, setSelectedData] = useState({
      startDate: item.exitDate || "",
      endDate: item.resignationDate || ""
    });

    useEffect(() => {
      if (resetDates) {
        const today = new Date().toISOString().split("T")[0]; // YYYY-MM-DD format
        setSelectedData({
          startDate: item.resignationDate || ''
        });
        const from = changeDateFromYYYYMMDDToDDMMYYYY(item.resignationDateDate || '');
      }
    }, [resetDates, item.exitDate]);

    const getValidDateOrToday = (dateStr) => {
      if (!dateStr) return new Date().toISOString().split('T')[0];
      // Extract date part if datetime string is passed
      const dateOnly = dateStr.split('T')[0];
      // Regex to match YYYY-MM-DD
      const isoDateRegex = /^\d{4}-\d{2}-\d{2}$/;
      if (isoDateRegex.test(dateOnly)) {
        return dateOnly;
      }
      // fallback to today
      return new Date().toISOString().split('T')[0];
    };

    const onShowCalendarPressDoe = () => {
      setFieldName('exitDate')
      const validDate = getValidDateOrToday(item.exitDate);
      setSelectedData({
        startDate: validDate,
        endDate: validDate,
      });
      setShowCalendarDoe(!showCalendarDoe);
      setShowCalendarDor(false);
    };

    const onShowCalendarPressDor = () => {
      setFieldName('resignationDate')
      const validDate = getValidDateOrToday(item.resignationDate);
      setSelectedData({
        startDate: validDate,
        endDate: validDate,
      });
      setShowCalendarDor(!showCalendarDor);
      setShowCalendarDoe(false);
    };

    const handleDateChange = (newDates) => {
      const today = new Date().toISOString().split("T")[0];
      setSelectedData(newDates);
      if (fieldName === 'exitDate') {
        const safeIssue =
          !newDates?.startDate || newDates.startDate.trim() === "" ? today : newDates.startDate;
        handleEditPress(index, item, 'exitDate', safeIssue);
      } else if (fieldName === 'resignationDate') {
        // if you're using range, prefer endDate; if single date, fall back to startDate
        const picked = newDates?.endDate && newDates.endDate.trim() !== ""
          ? newDates.endDate
          : (newDates?.startDate || today);
        handleEditPress(index, item, 'resignationDate', picked);
      }
      // optional: close whichever calendar was open
      setShowCalendarDoe(false);
      setShowCalendarDor(false);
    };

    const toggleExpand = () => {
      setIsExpanded(!isExpanded);
    };

    const CreateDivider = () => {
      return (
        <View
          style={{
            borderBottomColor: '#000000',
            borderBottomWidth: StyleSheet.hairlineWidth,
          }}
        />
      );
    };

    const removeAttachment = useCallback((index, item) => {
      handleEditPress(index, item, "fileName", '');
      handleEditPress(index, item, "fileType", '');
      handleEditPress(index, item, "fileData", null);
    }, [handleEditPress, index, item]);

    const showAttachment = (index, item) => {
      //* the attachment section to be shown/hidden
      return (
        <View>
          <View style={styles.attachmentContainer}>
            <View style={styles.attachmentIcons}>
              <Ionicons
                name="document-outline"
                style={styles.icons}
              />
            </View>
            <View style={styles.attachmentNameContainer}>
              <CustomText style={styles.attachmentNameText}>{item.fileName}</CustomText>
            </View>
            <View style={styles.attachmentIcons}>
              <Menu
                renderer={renderers.SlideInMenu}
                style={styles.attachmentMenu}
              >
                <MenuTrigger>
                  <Ionicons
                    name="ellipsis-vertical"
                    style={styles.dotsIcon}
                  />
                </MenuTrigger>
                <MenuOptions customStyles={optionsStyles}>
                  <MenuOption onSelect={() => openAttachment(index, item)} customStyles={cancelOptionStyles} text={t('common:open')}>
                  </MenuOption>
                  {CreateDivider()}
                  <MenuOption onSelect={() => downloadAttachment(index, item)} customStyles={cancelOptionStyles} text={t('common:downloadDocument')}>
                  </MenuOption>
                  {CreateDivider()}
                  <MenuOption onSelect={() => removeAttachment(index, item)} customStyles={removeOptionStyles} text={t('common:remove')}>
                  </MenuOption>
                  {CreateDivider()}
                  <MenuOption customStyles={cancelOptionStyles} text={t('common:cancel')}>
                  </MenuOption>
                </MenuOptions>
              </Menu>
            </View>
          </View>
        </View>
      );
    };

    const downloadAttachment = useCallback(async (index, item) => {
      let downloadName = '';
      const fileName = item.fileName;
      const fileType = item.fileType?.toLowerCase();
      if (fileName?.toLowerCase().endsWith(`.${fileType}`)) {
        downloadName = fileName;
      } else {
        downloadName = `${fileName || item.name || 'file_' + index}.${fileType}`;
      };

      const mimeType = fileType ? `application/${fileType}` : 'application/octet-stream';

      // create blob
      const blobData = await fetch(`data:plain/text;base64,${item.fileData}`).then(res => {
        return res.blob();
      });
      // create download link
      const url = URL.createObjectURL(blobData);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        'download',
        downloadName
      );

      // insert link on page
      document.body.appendChild(link);

      // start download
      link.click();

      // remove link
      link.remove();

      URL.revokeObjectURL(url);
    }, []);

    const openAttachment = async (index, item) => {
      const newWindow = window.open('', '_blank');
      if (!newWindow) {
        alert('Popup blocked. Please allow popups for this site.');
        return;
      };
      let base64Data = item.fileData;
      let type = item.fileType.toLowerCase();
      let style = '';

      if (type === 'pdf') {
        type = 'application/pdf';
        style = 'width: 100%; height: 100%; display: block;';
      } else if (['png', 'jpg', 'jpeg', 'gif'].includes(type)) {
        type = `image/${type}`;
        style = 'display: block; max-width: 100%; height: auto;';
      } else {
        // fallback MIME type
        type = 'application/octet-stream';
        style = 'display: block; max-width: 100%; height: auto;';
      }

      const uri = `data:${type};base64,${base64Data}`;

      newWindow.document.write(`
                          <html>
                            <head>
                              <title>${item.fileName || item.name || 'file_' + index}</title>
                              <style>
                                embed { ${style} }
                              </style>
                            </head>
                            <body style="margin:0">
                              <embed src="${uri}" type="${type}" />
                            </body>
                          </html>
                        `);
      newWindow.document.close();
    };

    const pickDocument = useCallback(async (index, item) => {
      //* select attachment
      // TODO: get size from oasis settings (DB)
      const maxSize = 30 * 1048576;
      let file = null;
      let uri = null;
      let type = null;
      let ext = null;

      try {
        // TODO: add types in constants file, and get them from there
        let result = await ExpoDocumentPicker.getDocumentAsync({
          type: [
            "image/jpeg",
            "image/gif",
            "image/png",
            "application/pdf",
            "application/msword",
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            "application/vnd.ms-excel",
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          ],
          copyToCacheDirectory: false,
          multiple: false,
        });

        if (!result.canceled) {
          file = result.output[0];
          type = result.assets[0].mimeType;
          uri = result.assets[0].uri.split(";base64,")[1];
          name = file.name;
          ext = name.includes('.') ? name.split('.').pop().toLowerCase() : '';
        } else {
          return;
        };

        // if size allowed
        if (file.size < maxSize) {
          handleEditPress(index, item, "fileName", name);
          handleEditPress(index, item, "fileType", ext);
          handleEditPress(index, item, "fileData", uri);
        } else {
          // file is too large
          showMessage({
            message: t('common:errFile'),
            type: "warning",
            duration: 3000,
          });
        };
      } catch (error) {
        console.error(error);
      };
    }, []);

    return (
      <SafeAreaView>
        <SafeAreaView style={styles.row}>
          <View style={[styles.item]}>
            <CustomDropDown
              defValue={item.reasonForLeavingId}
              options={emplExitProcessHelper.ReasonForLeavingId}
              value={item.reasonForLeavingId}
              setValue={(e) =>
                handleEditPress(index, item, "reasonForLeavingId", e)
              }
              type="FULL"
            />
          </View>
          <View style={[styles.item]}>
            <CustomDropDown
              defValue={item.interviewerId}
              options={emplExitProcessHelper.InterviewerId}
              value={item.interviewerId}
              setValue={(e) =>
                handleEditPress(index, item, "interviewerId", e)
              }
              type="FULL"
            />
          </View>
          <View style={[styles.containerCalendar]}>
            <SafeAreaView style={[styles.row, { marginLeft: 10 }]}>
              <CustomInput
                value={formatDateForUI(item.exitDate)}
                setValue={() => { }}
                maxLen={50}
                editable={false}
                type="MAININPUT"
              />
              <Ionicons
                name={showCalendarDoe ? "calendar" : "calendar-outline"}
                style={styles.icons}
                onPress={onShowCalendarPressDoe} // Doe: date of exit
              />
            </SafeAreaView>
          </View>
          <View style={[styles.containerCalendar]}>
            <SafeAreaView style={[styles.row, { marginLeft: 10 }]}>
              <CustomInput
                value={formatDateForUI(item.resignationDate)}
                setValue={() => { }}
                maxLen={50}
                editable={false}
                type="MAININPUT"
              />
              <Ionicons
                name={showCalendarDor ? "calendar" : "calendar-outline"}
                style={styles.icons}
                onPress={onShowCalendarPressDor} // Dor: date of registration
              />
            </SafeAreaView>
          </View>
          <View style={[styles.item]}>
            <SafeAreaView style={[styles.row]}>
              <View style={item.fileData ? styles.attachmentsExistView : styles.attachmentsNotExistView}>
                {item.fileData ?
                  (showAttachment(index, item)) :
                  <CustomLabel type='AVAILABLEUSED' value={t('common:noAttachment')} />}
              </View>
              <Ionicons
                name={"attach-outline"}
                style={[styles.icons, { fontSize: 30 }]}
                onPress={() => pickDocument(index, item)}
              />
            </SafeAreaView>
          </View>
          <SafeAreaView style={[styles.itemCheck]}>
            <CustomLabel value={t('common:voluntary')} type="AVAILABLEUSED_SECONDARY" />
            <Checkbox
              status={item.isProblematic ? 'checked' : 'unchecked'}
              onPress={() => handleEditPress(index, item, 'isProblematic', !item.isProblematic)}
              color={item.isProblematic ? '#86BC25' : undefined}
            />
          </SafeAreaView>
          <SafeAreaView>
            <CustomButton
              iconName="trash-outline"
              onPress={() => handleDelete(item, index, 'rowguid')}
              show="HOME_BELL"
              type="HOME_BELL"
              textTop="2"
              sz={30}
            />
            {/* <Ionicons
                name={
                  isExpanded
                    ? "chevron-down-outline"
                    : "chevron-forward-outline"
                }
                style={styles.icons}
                onPress={toggleExpand}
              /> */}
          </SafeAreaView>
        </SafeAreaView>
        {(showCalendarDoe || showCalendarDor) && (
          <>
            <SafeAreaView style={styles.calendarNoOverlay}>
              <CustomCalendar
                calendarType={"RangePicker"}
                setRange={handleDateChange}
                range={selectedData}
                allowSingleDate={true}
                startingYear={1950}
              />
            </SafeAreaView>
          </>
        )}
        {true && (
          <SafeAreaView style={styles.row2}>
            <View style={[styles.item]}>
              <CustomLabel value={t("common:newEmpl")} type="SUBTITLE" />
              <CustomInput
                value={item.newJob}
                setValue={(text) => {
                  handleEditPress(index, item, "newJob", text);
                }}
                editable={true}
                maxLen={255}
                type="MAININPUT"
              />
            </View>
          </SafeAreaView>
        )}
      </SafeAreaView>
    );
  }
);

const HRAdminEmplExitProcess = (props) => {
  const { width } = useWindowDimensions();
  const { colors } = useTheme();
  const common = createCommonStyles(colors);
  const styles = makeStyles(colors, width);
  const ref = useRef(null);
  const { t } = useTranslation();

  const [originalData, setOriginalData] = useState([]);
  const [emplExitProcessHelper, setExitProcessHelper] = useState({});
  const [changes, setChanges] = useState({});
  const [exitProcess, setExitProcess] = useState([]);
  const [deletedItems, setDeletedItems] = useState([]);
  const [resetDates, setResetDates] = useState([false]);
  const { isLoading, GetExitProcess, GetExitProcessHelper, SaveExitProcess, DeleteExitProcess } = useHRAdminEmployees();
  const { rowAdd, rowEdit, rowDelete } = useTableHelper();

  useEffect(() => {
    loadData();
  }, [props.selectedEmployee, props.selectedCompany]);

  const loadData = () => {
    GetExitProcessHelper().then((resp) => {
      setExitProcessHelper(resp);
      GetExitProcess(props.selectedEmployee.employeeID).then((resp) => {
        setExitProcess(resp);
        setOriginalData(resp);
      }).catch((error) => console.error(error))
    }).catch((error) => console.error(error))
  }

  const handleEditPress = useCallback(
    async (index, item, key, value) => {
      // Check if the value has changed
      if (item[key] === value) return;
      // Store the original value for potential rollback
      // Use rowEdit to apply the change
      rowEdit(
        index,
        item,
        key,
        value,
        changes,
        setChanges,
        exitProcess,
        setExitProcess
      );
    },
    [rowEdit, changes, exitProcess]
  );

  const removeFromChangesAfterSave = () => {
    setDeletedItems([]);
    setChanges({});
  };

  const handleDelete = (item, index, attribute) => {
    rowDelete(item, index, attribute, changes, setChanges, exitProcess, setExitProcess, setDeletedItems, ref)
  }

  const handleCancelChanges = () => {
    const rolledBackExit = originalData.map((obj) => ({ ...obj }));
    setExitProcess(rolledBackExit);
    setDeletedItems([]);
    setChanges({});
    showMessage({
      message: t("common:changesCancelled"),
      type: "info",
      duration: 3000,
    });
    setResetDates(true);
  };

  const validateInput = () => {
    let ret = [true, t('common:validationSuccess')]
    exitProcess.forEach((itr) => {
      if (itr.reasonForLeavingId === '')
        ret = [false, t('common:reasonEmpty')]
      else if (itr.interviewerId === '')
        ret = [false, t('common:interviewerEmpty')]
      else if (!itr.exitDate || !itr.resignationDate)
        ret = [false, t('common:dateEmpty')]
    })
    return (ret)
  }

  const handleSave = async () => {
    try {
      if (Object.entries(changes).length == 0 && deletedItems.length == 0) {
        showMessage({
          message: t('common:noChanges'),
          type: "danger",
          duration: 3000,
        })
        return;
      }

      let valRet = validateInput();
      if (!valRet[0]) {
        showMessage({
          message: valRet[1],
          type: "danger",
          duration: 3000,
        })
        return;
      }

      let savePromises = [];
      let updateSucc = true;
      let deleteSucc = true;

      savePromises.push(
        SaveExitProcess(
          changes,
          props?.selectedEmployee?.employeeID
        ).then((resp) => {
          updateSucc = resp;
        }).catch((error) => {
          console.error("Save error", error);
          updateSucc = false;
        })
      );

      if (deletedItems.length > 0) {
        savePromises.push(DeleteExitProcess(deletedItems)
          .then((res) => {
            deleteSucc = res;
          }).catch((error) => {
            console.error('delete failed', error);
            deleteSucc = false;
          }))
      };

      // Wait for all promises to resolve
      await Promise.all(savePromises);

      // === Handle results ===
      if (!updateSucc || !deleteSucc) {
        showMessage({
          message: t("common:errorSave"),
          type: "danger",
          duration: 3000,
        });
        return;
      }

      // * Reload after save
      loadData();
      removeFromChangesAfterSave();
      setResetDates(true);

      // === Success message ===
      showMessage({
        message: t("common:changesSavedSuccessfully"),
        type: "success",
        duration: 3000,
      });

    } catch (error) {
      console.error("Save error", error);
      showMessage({
        message: t("common:errorSave"),
        type: "danger",
        duration: 3000,
      });
    }
  };

  const renderExitProcess = useCallback(
    ({ item, index }) => (
      <Card style={[common.cardstyle]}>
        <Card.Content>
          <ExitProcessListView
            item={item}
            index={index}
            handleEditPress={handleEditPress}
            emplExitProcessHelper={emplExitProcessHelper}
            styles={styles}
            t={t}
            handleDelete={handleDelete}
            resetDates={resetDates}
          />
        </Card.Content>
      </Card>
    ),
    [
      exitProcess,
      handleEditPress,
      handleDelete,
      styles,
    ]
  );

  if (isLoading) {
    return (
      <View style={styles.loader}>
        <ActivityIndicator animating={true} color={colors.blue} />
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.mainView}>
      <View style={styles.container}>
        <View style={[styles.buttons, styles.functionalityButtons]}>
          <CustomButton
            text={t("common:new")}
            onPress={() => {
              rowAdd(
                exitProcess,
                setExitProcess,
                ['rowguid', 'employeeId'],
                ['isProblematic'],
                ref,
                t,
                ['employeeId'],
                [],
                changes,
                setChanges,
                undefined,
                undefined,
                "rowguid",
                false,
                ['exitDate', 'resignationDate']
              );
            }}
            type="BUTTON_ADD"
            textTop="0"
            sz={15}
          />
          {(Object.keys(changes).length > 0 ||
            changes.length > 0 || deletedItems.length > 0) && (
              <CustomButton
                text={t("common:saveFunction")}
                onPress={handleSave}
                type="BUTTON_SAVE"
                isGradient={true}
                textTop="0"
                sz={15}
              />
            )}
          <CustomButton
            text={t("common:cancel")}
            onPress={handleCancelChanges}
            type="BUTTON_CANCEL"
            textTop="0"
            sz={15}
          />
        </View>
        <FlatList
          data={exitProcess}
          keyExtractor={(item, index) => `${item.rowguid}-${index}`}
          renderItem={renderExitProcess}
          refreshing={isLoading}
          ref={ref}
          ListHeaderComponent={
            <SafeAreaView style={common.listTitle}>
              <SafeAreaView style={styles.row}>
                <CustomLabel value={t("common:reason")} type="SUBTITLE" />
                <CustomLabel value={t("common:interviewer")} type="SUBTITLE" />
                <CustomLabel value={t("common:exitdate")} type="SUBTITLE" />
                <CustomLabel value={t("common:resignationDate")} type="SUBTITLE" />
                <CustomLabel value={t("common:doc")} type="SUBTITLE" />
                <SafeAreaView style={[{ marginRight: '13%' }]} />
              </SafeAreaView>
              <SafeAreaView style={common.divider} />
            </SafeAreaView>
          }
          ListEmptyComponent={
            isLoading ? (
              <ActivityIndicator animating={true} color={colors.blue} />
            ) : (
              // will not be shown because API returns empty row
              // TODO: remove, and make isLoading work correctly
              <CustomLabel
                value={t("common:noExitProcessDataPreview")}
                type="NO_FUNCTIONS"
              />
            )
          }
          initialNumToRender={4}
        />
      </View>
    </SafeAreaView>
  );
};

const makeStyles = (colors, width) =>
  StyleSheet.create({
    mainView: {
      flex: 1,
    },
    rowView: {
      flex: 1,
      flexDirection: "row",
      justifyContent: "center",
    },
    container: {
      flex: 1,
    },
    calendarNoOverlay: {
      flex: 1,
      minHeight: 295,
      justifyContent: "center",
      alignSelf: "center",
      alignItems: "center",
    },
    containerCalendar: {
      justifyContent: "center",
      marginRight: 6,
      alignSelf: "center",
      alignItems: "center"
    },
    itemCheck: {
      flexDirection: 'row',
    },
    row: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
    },
    row2: {
      flex: 1,
      flexDirection: "row",
      alignItems: "center",
      margin: 10
    },
    item: {
      flex: 1,
      justifyContent: "center",
      marginRight: 6
    },
    buttons: {
      flexDirection: "row",
      justifyContent: "flex-end",
      alignSelf: "flex-end",
      marginRight: 15,
    },
    functionalityButtons: {
      justifyContent: "flex-end",
    },
    loader: {
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "4%",
    },
    icons: {
      fontSize: 24,
      marginHorizontal: 10,
    },
    attachmentContainer: {
      flexDirection: 'row',
      borderRadius: 10,
      marginHorizontal: '3%',
      marginVertical: '1%',
      justifyContent: 'center',
      alignItems: 'center',
    },
    attachmentsNotExistView: {
      flex: 1,
      borderColor: colors.border_card,
      borderWidth: 2,
      elevation: 5,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      shadowColor: colors.card_line,
      backgroundColor: colors.background_card,
      borderRadius: 10,
      padding: 5,
      margin: 10,
    },
    attachmentIcons: {
      width: 20,
      alignSelf: 'center',
      color: colors.text_primary,
    },
    attachmentNameContainer: {
      flex: 7,
      alignItems: 'flex-start',
      paddingHorizontal: 12,
    },
    attachmentNameText: {
      fontSize: 16,
      color: colors.text_primary,
      alignSelf: 'center',
    },
    dotsIcon: {
      fontSize: 21,
      color: colors.text_primary
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 998,
    },
    attachmentsExistView: {
      flex: 1,
      borderColor: colors.border_card,
      borderWidth: 1,
      elevation: 5,
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.3,
      shadowRadius: 5,
      shadowColor: colors.card_line,
      backgroundColor: colors.background_card,
      borderRadius: 10,
      padding: 5,
      margin: 10,
    },
  });
const optionsStyles = {
  optionsContainer: {
    marginHorizontal: '3.5%',
    marginVertical: '-3%',
    borderRadius: 10,
  },
  optionWrapper: {
    height: 50,
    justifyContent: 'center',
  },
};
const removeOptionStyles = {
  optionText: {
    textAlign: 'center',
    fontSize: 16,
    color: '#dd3636',
  },
};
const cancelOptionStyles = {
  optionText: {
    textAlign: 'center',
    fontSize: 16,
  },
};

export default HRAdminEmplExitProcess;